export default __webpack_public_path__ + "static/media/e.6abe1203.jpg";